






















import { Prop } from "vue-property-decorator";
import { Component, Mixins } from "vue-mixin-decorator";
import TabsComponent from "@/app/basic/common/components/tab-component/TabsComponent.vue";
import ComponentVue from "@/app/core/window/ComponentVue";

@Component({
  components: { TabsComponent }
})
export default class SButton extends Mixins<ComponentVue>(ComponentVue) {
  @Prop({ type: String, required: true })
  private icon!: string;

  @Prop({ type: String, default: "skyblue" })
  private colorStyle!: string;

  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  @Prop({ type: String, default: "" })
  private label!: string;
}
